module.exports = __webpack_public_path__ + "static/img/play-icon.4b96a11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/play-icon.jpg
// module id = fQ0C
// module chunks = 1